<div class="container">
  <div class="row" >
    <div class="col-md-6" >
      <div class="gauge" id="gaugeOne" [ngClass]="{ 'dark-graph': isDarkMode() }" ></div>

      <div class="gauge"  >
        <div class="row">
          <div class="col-md-10">
            <div
              class="temperature-info"
              *ngFor="let data of temperatureData"
              [style.color]="data.color"
            >
              <div class="label">{{ data.label }}</div>
              <div class="value">{{ data.value }}</div>
            </div>
          </div>
          <div
            class="col-md-2 d-flex align-items-center justify-content-center date" style="background-color: #d0d0d0;"
          >
           {{firstDate}}
          </div>
        </div>
      </div>

      <div class="gauge">
        <p class="text">ACTUAL CARGO TEMP. AGAINST VOYAGE PARAMETER</p>
      </div>
    </div>
    <div class="col-md-6 "   >
      <div class="gauge"  id="gaugeTwo"  [ngClass]="{ 'dark-graph': isDarkMode() }"></div>

      <div class="gauge">
        <div class="row">
          <div class="col-md-10" >
            <div
              class="temperature-info"
              *ngFor="let data of temperatureDataSecond"
              [style.color]="data.color"
              
            >
              <div class="label">{{ data.label }}</div>
              <div class="value">{{ data.value }}</div>
            </div>
          </div>
          <div
            class="col-md-2 d-flex align-items-center justify-content-center date" style="background-color: #c0e6f5"
          >
            {{secondDate}}
          </div>
        </div>
      </div>

      <div class="gauge">
        <p class="text">FORECAST CARGO TEMP. AGAINST VOYAGE PARAMETER</p>
      </div>
    </div>
  </div>
</div>